((app) => {
    //
    // Md-dialog's "this" refers to the window instead of the an
    // isolated scope. So we'll set $ctrl to an empty object instead 
    // to keep the template naming convention intact.
    //
    app.controller("fileProcessorTrackCtrl", ["$scope", "$mdDialog", "$q", "dataSourceApi", "processorTrackApi",
    ($scope, $mdDialog, $q, dataSourceApi, processorTrackApi) => {
        let $ctrl = {};
        $scope.$ctrl = $ctrl;
        $ctrl.currentStep = 0;
        $ctrl.dataSource = {};
        $ctrl.ui = { saving: false };

        $ctrl.$onInit = async () => {
            try {
                let results = await $q.all([dataSourceApi.getAllDataSourceEntities(), processorTrackApi.getAllProcessors()]);
                $ctrl.dataSources = results[0];
                $ctrl.processors = results[1];
            } catch (err) {
                // toast
            }
        };
        
        //
        // This isn't a component controller so we have to manually call an
        // init function since the angular lifecyle doesnt exist. We'll just 
        // keep the same naming standard that angular uses.
        // 
        $ctrl.$onInit();

        $ctrl.close = () => {
            $mdDialog.cancel();
        };

        $ctrl.createDataSourceEntity = async () => {
            $ctrl.fileProcessorTrackName = _generateFileProcessorTrackName($ctrl.dataSource.Name, $ctrl.processor.Name);
            $ctrl.currentStep = 1;
        };

        function _generateFileProcessorTrackName(dataSourceEntity, processor) {
             return dataSourceEntity + " - " + processor;
        }

        $ctrl.createFileProcessorTrackId = async () => {
            try {
                $ctrl.ui.saving = true;
                if(!$ctrl.selectExisting) {
                    $ctrl.dataSource = await dataSourceApi.createDataSourceEntity($ctrl.dataSource.Name, $ctrl.dataSource.Description);
                }  
                let track = await processorTrackApi.createTrack($ctrl.dataSource.Id, $ctrl.fileProcessorTrackName, $ctrl.processor.ProcessorId);
                await processorTrackApi.createXRef(track.Id, $ctrl.processor.ProcessorId);
                $ctrl.close();
            } catch (err) {
                $ctrl.ui.saving = false;
                // toast
            }
        };
    }]);
})(window.app);
